<template>
  <div class="info-grid technology-content ">
    <div v-for="technology in technologies" class="info-item-group list">
      <CustomIcon
        :name="technology.icon"
        height="45" width="45"
        :color="$props[technology.variable] ? '#97C131' : '#D9D9D9'"
      />
      <label>{{ technology.title }}</label>
      <span>{{ $props[technology.variable] || 'None' }}</span>
    </div>

    <div v-if="technologies.length % 2 === 1" class="info-item-group empty"></div>
  </div>
</template>

<script>

export default {
  name: 'OtherDetailsTechnology',
  props: {
    technologyAggregation: {
      type: String,
      default: '',
    },
    technologyAccounting: {
      type: String,
      default: '',
    },
    technologyCrm: {
      type: String,
      default: '',
    },
    technologyDocument: {
      type: String,
      default: '',
    },
    technologyFinancial: {
      type: String,
      default: '',
    },
    technologyOther: {
      type: String,
      default: '',
    },
    technologyPortfolio: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    technologies: [
      {
        title: 'CRM',
        variable: 'technologyCrm',
        icon: 'srg-comments',
      },
      {
        title: 'Financial Planning',
        variable: 'technologyFinancial',
        icon: 'srg-planning-docs',
      },
      {
        title: 'Portfolio Rebalancing',
        variable: 'technologyPortfolio',
        icon: 'srg-prospectus',
      },
      {
        title: 'Document Management',
        variable: 'technologyDocument',
        icon: 'srg-document-management',
      },
      {
        title: 'Account Aggregation',
        variable: 'technologyAggregation',
        icon: 'srg-account-aggregation',
      },
      {
        title: 'Other',
        variable: 'technologyOther',
        icon: 'srg-tech-cloud',
      },
      {
        title: 'Accounting',
        variable: 'technologyAccounting',
        icon: 'srg-gears',
      },
    ],
  }),
}
</script>

<style scoped>
img {
  fill: #97C131;
}
.technology-content {
  background-color: #EFEFEF;
}
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-other/Technology.vue